import { BreakpointObserver } from '@angular/cdk/layout';
import { Service, inject } from '@angular/core';
import { map, type Observable } from 'rxjs';

/**
 * Service for checking the matching state of `@media` queries.
 */
@Service()
export class BreakpointObserverService {
	private readonly breakpointObserver = inject(BreakpointObserver);

	/**
	 * Gets an observable of boolean for the given queries that will emit
	 * new results whether the breakpoint is currently matching of the given queries.
	 * @param media Media query for observe.
	 */
	public createBreakpointObserver(media: string | readonly string[]): Observable<boolean> {
		return this.breakpointObserver.observe(media)
			.pipe(
				map(result => result.matches),
			);
	}

	/**
	 * Create breakpoint observer for mobile screens.
	 */
	public createMobileBreakpointObserver(): Observable<boolean> {
		const mobileBorderMediaQuery = '(max-width: 767px)';
		return this.createBreakpointObserver(mobileBorderMediaQuery);
	}
}
